export class Login {
    // public Id: number;
    public Email: string;
    public Password: string;
    public Status: number;
    constructor() { }
} 